import React,  { useState, useEffect }  from 'react';
import axios from 'axios';
import MemberInfo from '../../components/members/member';

import {FormControl , TextField, Grid ,Typography,  Card, CardContent , CardActions,Button } from '@mui/material/';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { DataGrid, GridToolbar , frFR } from '@mui/x-data-grid';
import DialogTitle from '@mui/material/DialogTitle';
import Autorize from '../../components/ui/autorize';
import Cookies from 'js-cookie'

import { getSessionValide ,getUserRule,getSessionExpirer } from '../../utils/userRule';

export default function Member() {

      
    const [Search,setSearch] = useState("");
    const [memberslist, setMemberslist] = useState({});
    const [memberid, setMemberid] = useState("");
    const [clubid, setClubid] = useState("");
    const [modalOpen, setModalOpen] = useState(false);
    const [modalHyperlinkNewMember, setmodalHyperlinkNewMember] = useState(false);
    

    const [errorAxios, setErrorAxios] = useState("false"); 
    const [ruleRead, setRuleRead] = useState(false); 
 

  /*
    const MyAxios = axios.create({
        headers: { 'Access-Control-Allow-Origin':  process.env.REACT_APP_API},       
        withCredentials: true,
        xsrfCookieName: 'token',
        xsrfHeaderName: 'X-XSRF-TOKEN',
    })*/
const MyAxios = axios.create({    
  headers: { Authorization: "Bearer "+ Cookies.get('token'),
          }      
})

    useEffect(() => {      
    
      const fetchData = async () => {
        let RuleRead_member = await getUserRule("read_member","");
        //alert(RuleRead_member);
        setRuleRead(RuleRead_member);
        //setSessionValide(getSessionExpirer());
      };
      fetchData(); // Appel de la fonction asynchrone

    



    });


    function RechercheParNom()    
    {

      MyAxios.get(process.env.REACT_APP_API + '/members/get/search/'+ Search)
      .then((res) => {     
         // let MyArray = [];
         /* for (const [key, value] of Object.entries(res.data[0])) {
              MyArray.push(key,value);
          }
          */
          setMemberslist(res.data);
         
         // console.log(Object.entries(this.state.currentMember));
      })
      .catch((error) => {
        setErrorAxios(true);
      });

    }

    
    function closeModal() {
       
        setModalOpen(false);

        
    }
    

    


    function openModal() {
        setModalOpen(true);
    }


    function handleChange(event) {
      const value = event.target.value;     
      setSearch(value);   
    }
  
    const onRowClicked = (row, event) => {        
      setMemberid(row.id); 
      setClubid(row.fk_club_master);      
      openModal();
    };

    
    const columns = [           
      {      field: 'id',            headerName: 'id' ,        width: 0 ,     hide: true}  ,
      {      field: 'fk_club_master',      headerName: 'Numéro de club' ,    width: 140 ,    }  ,         
      {      field: 'First_Name',     headerName: 'Prénom' ,  width: 150 ,     }  ,
      {      field: 'Last_Name',     headerName: 'Nom' ,    width: 150 ,   }  ,
  ];



  return (
    <div>
        <Autorize axiosError={errorAxios} ruleAcces={ruleRead} />
        {getMain()}
    </div>
);  
    
  function getMain() {


    if(ruleRead === true)
        { 
           return (
    
            <div><Grid container direction="row" spacing={2}>
                  <Grid item xs={3} container  > 
                        <TextField id="Search" value={Search} onChange={handleChange} label="Recherche possible: nom, prénom, email"  style={{ marginLeft: '10px',width:'400px' }}  />
                        </Grid> 
                      <Grid item xs={2} container  >   
                        <Button variant="containedFifth" onClick={RechercheParNom} >Rechercher</Button>
                  </Grid> 
              </Grid> 

                  <div style={{ height: 800, width: '900px' }}>
                        <DataGrid key="DataGridMember"   localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
                            rows={memberslist}
                            columns={columns}
                            pageSize={25}
                            rowsPerPageOptions={[25]}
                            onRowClick={(rowData) => onRowClicked(rowData.row)}
                            components={{ Toolbar: GridToolbar }} 
                            initialState={{
                                filter: {
                                  filterModel: {
                                    items: [{ columnField: 'Status', operatorValue: 'equals', value: 'Actif' }],
                                  },
                                },
                              }}
                            
                        />
                    </div>
                    
                    <Dialog key="DdialogMember"
                      sx={{ '& .MuiDialog-paper': { maxWidth: '90%', maxHeight: '90%' } }}
                      maxWidth="xs"                 
                      open={modalOpen}                
                      >
                      <DialogTitle>Fiche du membre</DialogTitle>
                      <DialogContent dividers>
                      <MemberInfo memberid={memberid} clubid={clubid}/>
                      </DialogContent>

                      <DialogActions>
                      <Button  variant="containedSecondary" onClick={closeModal}>Fermer               
                      </Button>

                      </DialogActions>
                    </Dialog>




              </div>
            );
         }

      }
  


    

};
